import { GroupDetails, LinkDetails, SubGroupDetails } from "../types/sitemapTypes";

export const sitemapGroupCreationInitialValues: GroupDetails = {
  id: "",
  name: "",
  nameEn: "",
  position: 1,
};

export const sitemapGroupCreationValuesOnEdit = (group: GroupDetails) => {
  return group;
};

export const sitemapSubGroupCreationInitialValues: SubGroupDetails = {
  mainGroupId: "",
  id: "",
  name: "",
  nameEn: "",
  position: 1,
};

export const sitemapSubGroupCreationValuesOnEdit = (group: SubGroupDetails) => {
  return group;
};

export const sitemapLinkCreationInitialValues: LinkDetails = {
  subGroupId: "",
  id: "",
  name: "",
  nameEn: "",
  link: "",
  position: 1,
};

export const sitemapLinkCreationValuesOnEdit = (group: LinkDetails) => {
  return group;
};
